import type { UiOperation } from './operations'
import type { ResourceKind } from './routine'

export type OperationRouteResolver = (operation: UiOperation) => string

export type ResourceDescriptor = {
  kind: ResourceKind
  routes: Record<string, OperationRouteResolver>
}

export function resolveOperationRoute(descriptors: readonly ResourceDescriptor[], operation: UiOperation): string | undefined {
  for (const descriptor of descriptors) {
    const resolver = descriptor.routes[operation.type]
    if (resolver) return resolver(operation)
  }

  return undefined
}

export function requireResourceId(operation: UiOperation): string {
  const { id } = operation
  if (typeof id !== 'string' || !/^[A-Za-z0-9_-]+$/.test(id)) {
    throw new Error(`${operation.type} needs a valid resource id`)
  }

  return id
}
